// Single source of truth for the CLIENT / AGENCY-facing brand name.
// Mirror of backend/utils/branding.py. The internal HiroJet ATS keeps its own
// name (INTERNAL_BRAND); every client/agency surface renders CLIENT_BRAND.
export const CLIENT_BRAND = 'HiroBase';
export const INTERNAL_BRAND = 'HiroJet';

// Client-ATS email sender identity — mirror of backend/utils/branding.py.
// All client-ATS email (invites, scheduling, notifications) sends from this
// real, monitored, reply-able address as "Hirobase <invites@hirojet.com>".
export const CLIENT_EMAIL_FROM_ADDRESS = 'invites@hirojet.com';
export const CLIENT_EMAIL_FROM_NAME = CLIENT_BRAND;

export function setClientTitle(suffix) {
  try {
    document.title = suffix ? `${suffix} · ${CLIENT_BRAND}` : CLIENT_BRAND;
  } catch {
    /* no-op (SSR / no window) */
  }
}

// ── Hostname-driven default landing ────────────────────────────────────────
// Hostnames that should treat the WORKSPACE APP (not the marketing site) as their
// root. When one of these custom domains is mapped to this deployment, visiting
// its root ("/") lands directly on the Hirobase workspace login instead of the
// HiroJet marketing site. Add future client-app domains here.
const WORKSPACE_HOST_PATTERNS = [
  /^hirobase\.hirojet\.com$/i,  // primary client-app subdomain
  /^hirobase\./i,               // any hirobase.* host
  /^app\./i,                    // any app.* host (e.g. app.hirojet.com)
];

export function isWorkspaceHost(hostname) {
  const h = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')) || '';
  return WORKSPACE_HOST_PATTERNS.some((re) => re.test(h));
}

// Route the site root ("/") should resolve to for the current host.
// Returns the workspace login on workspace/app hosts, else null (marketing home).
export function rootRedirectPath(hostname) {
  return isWorkspaceHost(hostname) ? '/workspace-login' : null;
}
